/**
 * Internal dependencies
 */
import BlockBeforeAfter from "./block-before-after";

/**
 * 
 */
class BlockBeforeAfterManager {

	/**
	 * Public vars
	 */
	contextDocument = document;
	blockList = [];
	blockSelector = '.block-before-after';

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		this.contextDocument.addEventListener( 'WMUViewportChange', this.onViewportChange );
	}

	/**
	 * 
	 */
	clear()
	{
		this.blockList.forEach( ( block ) =>
		{
			block.clear();
		} );

		this.blockList = [];
	}

	/**
	 * 
	 */
	setup()
	{
		this.contextDocument.querySelectorAll( this.blockSelector ).forEach( ( blockElement ) =>
		{
			const block = new BlockBeforeAfter( blockElement );
			block.setup();
			this.blockList.push( block );
		} );
	}

	/**
	 * Event handlers
	 */

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockBeforeAfterManager;